import { Component, Vue } from 'vue-property-decorator'
import { Route } from 'vue-router'
import store from '@/store'

@Component
export default class BaseTab extends Vue {
  async beforeRouteEnter(to: Route, from: Route, next: () => void) {
    const patientId = Number(to.params.patientId)
    await store.dispatch('patient/updateCurrentPatient', { patientId })
    next()
  }
}
